<template>
<div>
    <div class="modal print_modal" :class="{ 'open_modal': showFingerprintModal}">
        <div class="modal_overlay"></div>
        <div class="modal_inner max_height_80">
            <div class="modal_header">
                <h2>Finger Print</h2>
                <span class="close_icon close_icon_sm" @click="closeModal()">×</span>
            </div>
            <div class="modal_wrapper">
                <div class="modal_content modal_1400p">
                    <div class="row mt_10">
                        <div class="col_12">
                            <div :class="['form-group', {'has_error': errorFor('fingerprint')}]">
                                <label>{{ $t('sidebar.questions.fingerprint') }}</label>
                                <text-editor-component :id="'fingerprint'" :existingData="form.fingerprint ? form.fingerprint : ''" @change="changeEditorValue" />
                                <v-errors :errors="errorFor('fingerprint')" />
                            </div>
                        </div>
                        <div class="col_12">
                            <div :class="['form-group', {'has_error': errorFor('commentary_type')}]">
                                <label>{{ $t('common.commentary_type') }}</label>
                                <div class="form_inline">
                                    <div class="form_radio">
                                        <input type="radio" id="editor" value="1" v-model="form.commentary_type" @change="changeCommentaryType()">
                                        <label for="editor">{{ $t('common.editor') }}</label>
                                    </div>
                                    <div class="form_radio">
                                        <input type="radio" id="video_type" value="2" v-model="form.commentary_type" @change="changeCommentaryType()">
                                        <label for="video_type">{{ $t('common.video') }}</label>
                                    </div>
                                </div>
                                <v-errors :errors="errorFor('commentary_type')" />
                            </div>
                            <div class="row">
                                <template v-if="form.commentary_type == 1">
                                    <div class="col_12">
                                        <div :class="['form-group', {'has_error': errorFor('commentary')}]">
                                            <label>{{ $t('sidebar.questions.commentary') }}</label>
                                            <text-editor-component :id="'commentary'" :existingData="form.commentary ? form.commentary : ''" @change="changeEditorValue" />
                                            <v-errors :errors="errorFor('commentary')" />
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col_12" v-if="question_preview_videos.length">
                                        <div class="video_list">
                                            <div class="inner" v-for="(preview_video, index) in question_preview_videos" :key="index">
                                                <div class="inner_wrap">
                                                    <img :src="preview_video.thumbs" alt="" v-if="preview_video.convert_status == 'Completed'">
                                                    <img :src="baseUrl + 'assets/images/no_image.jpg'" alt="" v-else>
                                                    <div class="icons">
                                                        <span v-if="preview_video.smil" @click.prevent="showVideo(preview_video.smil)"><i class="lni lni-eye"></i></span>
                                                        <span><i class="lni lni-trash" @click.prevent="removeVideo(preview_video)"></i></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col_12">
                                        <div :class="['form-group', {'has_error': errorFor('video_upload')}]">
                                            <label>{{ $t('sidebar.lectureCommon.video_upload') }}</label>
                                            <div class="form_inline">
                                                <div class="form_radio">
                                                    <input type="radio" id="uploadVideo" value="2" v-model="form.video_upload_type" @change="changeVideoUploadType()">
                                                    <label for="uploadVideo">URL</label>
                                                </div>
                                                <div class="form_radio">
                                                    <input type="radio" id="uploadUrl" value="1" v-model="form.video_upload_type" @change="changeVideoUploadType()">
                                                    <label for="uploadUrl">{{ $t('common.video') }}</label>
                                                </div>
                                            </div>
                                            <template v-if="form.video_upload_type == 1">
                                                <vue-dropzone ref="upload_dropzone" id="upload_dropzone" 
                                                    :class="{'dropzone_disable' : dropzoneDisable}" 
                                                    @vdropzone-removed-file="vremoved" 
                                                    @vdropzone-success="uploadSuccess" 
                                                    :options="dropzoneOptions" 
                                                    :duplicateCheck="true">
                                                </vue-dropzone>
                                                <v-errors :errors="errorFor('question_videos')" />
                                            </template>
                                            <template v-if="form.video_upload_type == 2">
                                                <div :class="['form-group', {'has_error': errorFor('video_url')}]">
                                                    <input type="text" class="form_global" v-model="form.question_video_url">
                                                    <v-errors :errors="errorFor('video_url')"></v-errors>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="common_content">
                        <div class="common_content_btn d_flex_end">
                            <button class="btn btn_blue ml_5" @click="submitFingerprint()">{{ $t('common.save') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <video-modal v-if="videoModalShow" :showVideoModal="videoModalShow" :video="videoSmilFile" @closeModal="closeModal()"></video-modal>
</div>
</template>

<script>
import TextEditorComponent from "@/components/TextEditorComponent";
import vueDropzone from '../../lecture_management/components/dropzone';
import VideoModal from "../../lecture_management/components/VideoModal.vue";
export default {
    name: "FingerprintModal",
    components: {
        TextEditorComponent,
        vueDropzone,
        VideoModal
    },
    props: {
        showFingerprintModal: {
            type: Boolean,
            required: true
        },
        fingerprint: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE,
            form: {
                fingerprint: '',
                commentary: '',
                commentary_type: 1,
                question_video_url: '',
                question_video: '',
                video_upload_type: 2,
            },
            question_preview_videos: [],
            dropzoneOptions: {
                url: `${process.env.VUE_APP_API_BASE_URL}/upload/video`,
                thumbnailWidth: 150,
                maxFiles: 1,
                maxFilesize: 5368709120,
                uploadMultiple: true,
                allowMultiple: true,
                addRemoveLinks: true,
                acceptedFiles: "video/*",
                headers: {
                    "Authorization": `Bearer ` + JSON.parse(localStorage.getItem('admin')).token
                }
            },
            dropzoneDisable: false,
            videoModalShow: false,
            videoSmilFile: null,
        }
    },
    created() {
        if(this.fingerprint){
            this.form.fingerprint = this.fingerprint.fingerprint
            this.form.commentary = this.fingerprint.commentary
            this.form.commentary_type = this.fingerprint.commentary_type
            this.form.question_video_url = this.fingerprint.question_video_url
            this.form.question_video = this.fingerprint.question_video
            this.form.video_upload_type = this.fingerprint.video_upload_type
        }
    },
    methods: {
        vremoved(file) {
            console.log(file)
        },
        uploadSuccess(file, response) {
            let questionOriginalFile = '';
            if(response && response.length){
                questionOriginalFile = {
                    original_file: file.name,
                    file: response[0].original_filename
                }
            }

            this.form.question_video = questionOriginalFile
        },
        showVideo(smil) {
            this.videoSmilFile = smil
            this.videoModalShow = true
        },
        removeVideo(video) {
            let questionId = video.id
            console.log(questionId)
        },
        changeEditorValue(editorId, data) {
            this.form[editorId] = data
        },
        changeVideoUploadType() {
            if (this.form.video_upload_type == 1) {
                this.form.question_video_url = ''
            } else {
                this.form.question_video = ''
            }
        },
        changeCommentaryType(){
            if (this.form.commentary_type == 2) {
                this.form.commentary = ''
            }
        },
        submitFingerprint() {
            this.$emit('fingerprintData', this.form)
            this.closeModal();
        },
        closeModal() {
            this.$emit('closeModal')
        },
    }
}
</script>

<style scoped>
.modal_header h2 {
    text-align: center;
    padding: 20px 0px;
}

.search_btn {
    padding: 10px 10px 10px 15px;
    margin: 0px 10px 0px 0px;
}

.reset_btn {
    padding: 10px 10px 10px 15px;
}

.table tr td:nth-of-type(2) {
    text-align: center !important;
}
</style>
